import { useMemo } from 'react';

import { FieldSuggestionOption } from '../InputGroupWithSuggestions';

export const useAcceptedSuggestionIndex = (
  localValue: string | null,
  suggestions: FieldSuggestionOption[],
) =>
  useMemo(
    () => ({
      caseInsensitive: suggestions.findIndex(
        (suggestion) =>
          suggestion.value.toLowerCase().trim() ===
          localValue?.toLowerCase()?.trim(),
      ),
      caseSensitive: suggestions.findIndex(
        (suggestion) => suggestion.value.trim() === localValue?.trim(),
      ),
    }),
    [localValue, suggestions],
  );
